@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent editModelDetailComponent content">
    <irb-editor-sidebar-banner
      [accordian]="accordian"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="isModified"
      [isValid]="isValid"
      [hasPendingFunction]="hasPendingFunction"
      [slot]="slot"
      (save)="save()"
      (cancel)="cancel()">
      <span header class="ms-header" tooltip [tooltipTitle]="slideOutTitle" [tooltipRequiresTruncation]="true">
        <span>{{slideOutTitle}}</span>
      </span>
      <span buttonsInFront>
        @if (!showUnsavedChangesWarning) {
          <button class="btn-medium-primary" id="editorSideReBalanceButton"
            (click)="onCreateRebalance()"
            [disabled]="isModified || !isRebalanceBtnAnabled ? true : false"
          >Rebalance</button>
        }
      </span>
      <span buttonsInEnd>
        @if (modelEventData.showCopyModel && isCopyModelEnabled && !showUnsavedChangesWarning) {
          <button class="btn-medium-secondary" style="position: relative"
            (click)="onCopyModel()"
            [disabled]="isModified || !isValid || isSubscribeModel"
            >Create a copy
            @if (isSubscribeModel) {
              <div style="position:absolute; left:0; top:0; z-index: 9999; width: 101px; height: 24px;" tooltip tooltipPosition="bottom" tooltipTitle="You cannot create a copy of a Model Market Center Model"></div>
            }
          </button>
        }
        <button style="position: relative;" [matMenuTriggerFor]="subMenuSAC" class="btn-medium-secondary btnWithArrow"
          >Go to SAC<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
          <mat-menu #subMenuSAC="matMenu" class="nav__items_action_btn" yPosition="below">
            <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=R_MARK','_blank')">Research</button>
          </mat-menu>
        </button>
      </span>
    </irb-editor-sidebar-banner>
    <div [style.height]="bodyHeight" #body class="irb-editors-edit-model body">
      @if (showBack) {
        <div style="margin-bottom: 7px;" class="editor-model-prevnext">
          <a class="editor-model-blended" (click)="cancel()">< Back to Blended Model</a>
        </div>
      }
      @if (eventPrevNextObject && modelEventData && modelEventData.showNextPrev) {
        <editor-model-prevnext [eventPrevNextObject]="eventPrevNextObject"></editor-model-prevnext>
      }
      <!-- sa 2025-08-26 decision not to show for regular models: IREBAL-47294-47295 canceled -->
      <!--
      <div class="block  status-pending-review-warning" *ngIf="data.allowAutoRebalOnModelUpdate === 'PAUSED_FOR_REV'">
        <p class="message">
          <span>
            This model has been changed by the model provider. You can review the changes in Model History and resume automated rebalancing, leave it paused, or assign associated portfolios to a different model.
          </span>
        </p>
        <p class="actions">
          <a (click)="onResumeAutomatedRebalancing()">Resume Automated Rebalancing</a><span class="spacer"></span><a (click)="onDismissPendingReviewStatus()">Close and Leave Paused</a>
        </p>
      </div>
      -->
      @if (!isSubscribeModel) {
        <div class="block editorDisplayBanner editor-secure-model-banner" style="padding-bottom:0px;">
          <div class="subscribe-model-banner-item" style="min-width:245px;">
            <div class="subscribe-model-banner-title">Model Name
            </div>
            @if (!showInLineeditFlag) {
              <div class="subscribe-model-banner-value">{{ data.securityModelName }}
                <a class="editModelDetailEditLink" id="editLinkModelName2" (click)="showInlineEdit()">
                  <img src="../../../assets/images/edit.png" alt="Edit" style="height:14px;vertical-align:top;">
                </a>
              </div>
            }
            @if (showInLineeditFlag) {
              <irb-com-inlineedit [(tooltipMessage)]="tooltipMessage"
                defaultTooltip="Please provide valid model name."
                [(data)]="data.securityModelName"
                allowSpecialCharacters="true"
                (save)="saveInlineEdit($event)" (close)="closeInlineEdit()"
                maxlength="100"
              (change)="onTextChange()"></irb-com-inlineedit>
            }
          </div>
          <div class="subscribe-model-banner-item" style="min-width:245px;">
            <div class="subscribe-model-banner-title">Model Description <span style="color: #848484;font-weight: 400;">(optional)</span>
          </div>
          @if (!showInLineEditDescFlag) {
            <div class="subscribe-model-banner-value">{{ data.securityModelDescription }}
              <a class="editModelDetailEditLink" id="editLinkDescr2" (click)="showInlineDescEdit()">
                <img src="../../../assets/images/edit.png" alt="Edit" style="height:14px;vertical-align:top;">
              </a>
            </div>
          }
          @if (showInLineEditDescFlag) {
            <irb-com-inlineedit [(tooltipMessage)]="tooltipDescMessage"
              defaultTooltip="Please provide valid model description."
              [(data)]="data.securityModelDescription"
              allowSpecialCharacters="true"
              (save)="saveInlineDescEdit($event)" (close)="closeInlineDescEdit()"
            maxlength="100"></irb-com-inlineedit>
          }
        </div>
        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Type</div>
          <div class="subscribe-model-banner-value">{{ data.modelType }}</div>
        </div>
        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Securities</div>
          <div class="subscribe-model-banner-value">{{ data.noOfSecurities }}</div>
        </div>
        @if (!(pfCount===undefined)) {
          <div class="subscribe-model-banner-item">
            <div class="subscribe-model-banner-title" style="padding-bottom:8px;">Portfolios</div>
            <a class="subscribe-model-banner-value" tooltip [tooltipTitle]="isModified ? 'The model has unsaved changes. You\'ll need to save the changes before navigating to the portfolios.': null"
              tooltipPosition="bottom"
            (click)="showPortfoliosByModel()">{{ pfCount || 0  }} {{(pfCount === 1) ? 'portfolio' : 'portfolios'}}</a>
          </div>
        }
        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Vendor Shared</div>
          <div class="subscribe-model-banner-value">
            <p-checkbox name="isVendorShared" [(ngModel)]="data.isVendorShared"
              [disabled]="data.isAPIEnabled" binary="true"
            (onChange)="onInputChange();"></p-checkbox>
          </div>
        </div>
        @if (ENABLE_SYNTAX_SSO && data && data.isSyntaxModel) {
          <div class="subscribe-model-banner-item" style="margin-top: 15px;">
            <button (click)="showSyntaxDialog()" class="btn-medium-secondary" id="edit-model-syntax-button">
              Syntax
              <img src="../../assets/images/external_black.png" class="external_icon" style="margin-left: 2px;width:12px;">
            </button>
          </div>
        }
        <!-- sa 2025-09-05 decision not to show for regular models: IREBAL-47294-47295 canceled -->
        <!--            <div class="subscribe-model-banner-item" *ngIf="globalSettingsData?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag">-->
        <!--                <div class="subscribe-model-banner-title">Allow Automated Rebalances-->
        <!--                    <img *ngIf="data.allowAutoRebalOnModelUpdate === 'PAUSED_FOR_REV'"-->
        <!--                    class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-bottom: -3px;">-->
      <!--                </div>-->
      <!--                <div class="mat-slide-toggle-container" calltoaction [calltoactionTemplate]="irebalAutomatedRebalanceTemplateRef"-->
      <!--                    calltoactionPosition="bottom"-->
      <!--                    calltoactionUsesHover="true">-->
      <!--                    <mat-slide-toggle [checked]="data.allowAutoRebalOnModelUpdate === 'ALLOWED'"-->
      <!--                    (change)="onAutoRebalanceEnabledChange()"-->
      <!--                    [disabled]="!globalSettingsData?.allowMMCPortApproval || !isUserAutoRebalanceEnabled">-->
    <!--                    </mat-slide-toggle>-->
  <!--                </div>-->
<!--            </div>-->
</div>
}
@if (isSubscribeModel) {
  @if (roles?.MMC_ADVISOR) {
    <div class="block" style="text-align: right;">
      <div><a class="nav-link-text" (click)="openInModelMarketCenter()">View more Model Details in the Model Market Center</a></div>
    </div>
  }
  @if (isPendingReviewBannerEnabled && data.allowAutoRebalOnModelUpdate === 'PAUSED_FOR_REV' && globalSettingsData?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag) {
    <div class="block  status-pending-review-warning">
      <div class="left" style="width: calc(100% - 50px);">
        <p class="message">
          <span>
            This model has been changed by the model provider. You can review the changes in Model History and resume automated rebalancing, leave it paused, or assign associated portfolios to a different model.
          </span>
        </p>
        <p class="actions">
          <a (click)="onResumeAutomatedRebalancing()">Resume Automated Rebalancing</a><span class="spacer"></span><a (click)="onDismissPendingReviewStatus()">Close and Leave Paused</a>
        </p>
      </div>
      <button class="banner-close right" title="Hide" style="min-width:30px"(click)="onClosePendingReviewBanner()"><i class="material-icons clear">clear</i></button>
      <div class="clear"></div>
    </div>
  }
  <div class="block editorDisplayBanner editor-subscribe-model-banner" style="padding-bottom:0px;">
    <div class="subscribe-model-banner-item">
      <div class="subscribe-model-banner-title">Manager</div>
      <div class="subscribe-model-banner-value">{{ data.modelProviderName }}</div>
    </div>
    <div class="subscribe-model-banner-item manager-model-name-width">
      <div class="subscribe-model-banner-title">Manager's Model Name</div>
      <div class="subscribe-model-banner-value">{{ data.modelMarketName }}</div>
    </div>
    <div class="subscribe-model-banner-item model-name-width" style="min-width:245px;">
      <div class="subscribe-model-banner-title">iRebal Model Name
        <span class="infoIcon"
          calltoaction [calltoactionTemplate]="irebalModelNameTemplateRef"
        calltoactionPosition="bottom"></span>
        <ng-template #irebalModelNameTemplateRef>
          Enter your own iRebal model name if desired. It will be shown as the name in your Models in Use
          and throughout iRebal.
        </ng-template>
      </div>
      @if (!showInLineeditFlag) {
        <div class="subscribe-model-banner-value">{{ data.securityModelName }}
          <a class="editModelDetailEditLink" id="editLinkModelName1" (click)="showInlineEdit()">
            <img src="../../../assets/images/edit.png" alt="Edit" style="height:14px;vertical-align:top;">
          </a>
        </div>
      }
      @if (showInLineeditFlag) {
        <irb-com-inlineedit [(tooltipMessage)]="tooltipMessage"
          defaultTooltip="Please provide valid model name."
          [(data)]="data.securityModelName"
          allowSpecialCharacters="true"
          (save)="saveInlineEdit($event)" (close)="closeInlineEdit()"
          maxlength="100"
        (change)="onTextChange()"></irb-com-inlineedit>
      }
    </div>
    <div class="subscribe-model-banner-item model-description-width" style="min-width:245px;">
      <div class="subscribe-model-banner-title">Model Description <span style="color: #848484;font-weight: 400;">(optional)</span>
    </div>
    @if (!showInLineEditDescFlag) {
      <div
        class="subscribe-model-banner-value">{{ data.securityModelDescription }}
        <a class="editModelDetailEditLink" id="editLinkDescr1" (click)="showInlineDescEdit()">
          <img src="../../../assets/images/edit.png" alt="Edit" style="height:14px;vertical-align:top;">
        </a>
      </div>
    }
    @if (showInLineEditDescFlag) {
      <irb-com-inlineedit [(tooltipMessage)]="tooltipDescMessage"
        defaultTooltip="Please provide valid model description."
        [(data)]="data.securityModelDescription"
        allowSpecialCharacters="true"
        (save)="saveInlineDescEdit($event)" (close)="closeInlineDescEdit()"
      maxlength="100"></irb-com-inlineedit>
    }
  </div>
  <div class="subscribe-model-banner-item">
    <div class="subscribe-model-banner-title">Type</div>
    <div class="subscribe-model-banner-value">{{ data.modelType }}</div>
  </div>
  <div class="subscribe-model-banner-item">
    <div class="subscribe-model-banner-title">Securities</div>
    <div class="subscribe-model-banner-value">{{ data.noOfSecurities }}</div>
  </div>
  @if (!(pfCount===undefined)) {
    <div class="subscribe-model-banner-item ">
      <div class="subscribe-model-banner-title" style="padding-bottom:8px;">Portfolios</div>
      <a class="subscribe-model-banner-value" tooltip [tooltipTitle]="isModified ? 'The model has unsaved changes. You\'ll need to save the changes before navigating to the portfolios.': null"
        tooltipPosition="bottom"
      (click)="showPortfoliosByModel()">{{ pfCount || 0 }} {{(pfCount === 1) ? 'portfolio' : 'portfolios'}}</a>
    </div>
  }
  <div class="subscribe-model-banner-item  medium-second-line-width">
    <div class="subscribe-model-banner-title">Strategist Fee
      <span class="infoIcon"
        calltoaction [calltoactionTemplate]="strategistFeeTemplateRef"
      calltoactionPosition="bottom"></span>
      <ng-template #strategistFeeTemplateRef>
        This number represents the cost – in basis points – assessed to the advisor for using this
        model/product. It is otherwise known as a strategist fee. This number does not include the
        underlying fund expenses that an investor will pay for purchasing securities included in the
        model's allocations.
      </ng-template>
    </div>
    <div class="subscribe-model-banner-value">{{ data.costBPs }} BPS</div>
  </div>
  @if (globalSettingsData?.isAutoRebalanceEnabled && isMMCAutomationEnabledFlag) {
    <div class="subscribe-model-banner-item medium-second-line-width">
      <div class="subscribe-model-banner-title">Allow Automated Rebalances
        @if (data.allowAutoRebalOnModelUpdate === 'PAUSED_FOR_REV' && isSubscribeModel) {
          <img
            class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-bottom: -3px;">
          }
        </div>
        <div class="mat-slide-toggle-container" calltoaction [calltoactionTemplate]="irebalAutomatedRebalanceTemplateRef"
          calltoactionPosition="bottom"
          calltoactionUsesHover="true">
        <mat-slide-toggle [checked]="data.allowAutoRebalOnModelUpdate === 'ALLOWED'"
          (change)="onAutoRebalanceEnabledChange()" [disabled]="data.allowAutoRebalOnModelUpdate === 'PAUSED_FOR_REV' || !globalSettingsData?.allowMMCPortApproval || !isUserAutoRebalanceEnabled">
        </mat-slide-toggle>
      </div>
    </div>
  }
</div>
}
<mat-accordion #accordian="matAccordion" [multi]="true">
  <mat-expansion-panel id="SECURITYMODELHISTORY" [expanded]="securityAllocationHistoryState"
    (opened)="onOpenHistoryPanel();"
    (closed)="onCloseHistoryPanel()">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Model History @if (data.isRead !== undefined && !data.isRead && isSubscribeModel && !historyPanelOpened) {
        <img
          class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-bottom: 3px; margin-left:10px">
        }
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      @if (data.isRead !== undefined && !data.isRead && isSubscribeModel) {
        <div class="block  status-pending-review-warning">
          <p class="message">
            <span>
              This model has been changed by the model provider. You can review new and previous changes in the Model History table.
            </span>
          </p>
        </div>
      }
      @if (historyData && !isUiTest) {
        <irb-security-model-history [data]="historyData"
          [createModifyData]="createModifyData"
        modelType="Security"></irb-security-model-history>
      }
    </ng-template>
  </mat-expansion-panel>
  <mat-expansion-panel id="SECURITYALLOCATIONS" [expanded]="securityAllocationState"
    (opened)="ies.updateExpansionState('SECURITYALLOCATIONS','opened')"
    (closed)="ies.updateExpansionState('SECURITYALLOCATIONS','closed')">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Security Allocations
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    @if (data && !isUiTest) {
      <irb-security-allocations [(data)]="data" [slot]="slot"
        [isSubscribeModel]="isSubscribeModel"
      (changeData)="onInputChange()"></irb-security-allocations>
    }
  </ng-template>
</mat-expansion-panel>
<mat-expansion-panel id="ALLOCATIONCHART" [expanded]="securityAllocationChartState"
  (opened)="ies.updateExpansionState('ALLOCATIONCHART','opened')"
  (closed)="ies.updateExpansionState('ALLOCATIONCHART','closed')">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Allocations Chart
      @if (ENABLE_SEC_GRID_CHART) {
        <span style="margin-left: auto">
          <button class="btn-slim-primary settings-right" style="margin-right: 10px;" (click)="$event.stopPropagation(); showAllocationCustomView = true;" [disabled]="showAllocationCustomView">Customize view</button>
        </span>
      }
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    @if (ENABLE_SEC_GRID_CHART) {
      @if (data && !isUiTest) {
        <irb-security-allocations-chart
          modelType="Base"
        [(showCustomView)]="showAllocationCustomView"></irb-security-allocations-chart>
      }
    } @else {
      @if (data && !isUiTest) {
        <irb-legacy-allocations-chart
        modelType="Base"></irb-legacy-allocations-chart>
      }
    }
  </ng-template>
</mat-expansion-panel>
</mat-accordion>
</div>
</div>
}
<ng-template #irebalAutomatedRebalanceTemplateRef>
  @if (!globalSettingsData?.allowMMCPortApproval && isUserAutoRebalanceEnabled) {
    Automated rebalancing is currently disabled for all MMC models. This can be changed in iRebal settings.
  }
  @if (globalSettingsData?.allowMMCPortApproval && isUserAutoRebalanceEnabled && data?.allowAutoRebalOnModelUpdate === 'PAUSED_FOR_REV') {
    This enables automated rebalancing for this model in its current state. You will be notified of any model changes.
  }
  @if (!isUserAutoRebalanceEnabled) {
    Automated rebalancing is currently enabled for this MMC model. Contact an FSA for the permissions needed to adjust this setting.
  }
  @if (!(!globalSettingsData?.allowMMCPortApproval && isUserAutoRebalanceEnabled) &&
    !(globalSettingsData?.allowMMCPortApproval && isUserAutoRebalanceEnabled && data?.allowAutoRebalOnModelUpdate === 'PAUSED_FOR_REV') && isUserAutoRebalanceEnabled) {
    @if (data.allowAutoRebalOnModelUpdate === 'ALLOWED') {
      <!-- checked -->
      Automated rebalancing is currently allowed for this MMC model.
    }
    @if (!(data.allowAutoRebalOnModelUpdate === 'ALLOWED')) {
      Automated rebalancing is currently not allowed for this MMC model.
    }
  }
</ng-template>
